export const PACKAGE_NAME = 'jiraJetPlanActionMenu';
export const TEAM_NAME = 'jet-chronos-team';

export const DUPLICATE = 'DUPLICATE' as const;
export const ARCHIVE = 'ARCHIVE' as const;
export const TRASH = 'TRASH' as const;

export const PLAN_MENU_SUBJECT_ID = 'plansNavigationMenuItem';
